import { render, staticRenderFns } from "./BroadcastsLocalFilters.vue?vue&type=template&id=7c415da1&"
import script from "./BroadcastsLocalFilters.vue?vue&type=script&lang=js&"
export * from "./BroadcastsLocalFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports